import { memo, useContext } from "react";
import Credentials from "./Credentials";
import { Button, Grid } from "antd";
import IntlMessages from "components/Message/IntlMessages";
import Img_left from "assets/images/img-login-left.png";
import useDesktopDetection from "components/hooks/useDesktopDetection";
import ImgNextWhite from "assets/images/logo-next-white.svg";
import ImgNext from "assets/images/logo-next.svg";
import { LoginContext, LoginType } from "..";
import DangerousMessage from "components/Message/DangerousMessage";
import { useIntl } from "react-intl";
import moment from "moment-timezone";
import { getRuntimeEnv } from "const";

const SignInSection = () => {
  const intl = useIntl();
  const screens = Grid.useBreakpoint();
  const isMobile = !useDesktopDetection("lg");
  const { tabLoginType, enableLogin, gotoNormalLogin } = useContext(LoginContext);

  const nextAuth = () => {
    window.open(getRuntimeEnv("REACT_APP_NEXT_AUTH_DEEP_LINK"), "_blank");
  };

  if (isMobile && tabLoginType !== LoginType.NORMAL) {
    return (
      <div className="mobile-container h-100 d-flex flex-column">
        {/* Header Title */}
        <div className="m-header">
          <label className="color-yellow fw-bold">{<IntlMessages id="login.title.main-mobile-line-1" />}</label>
          <label className="color-yellow fw-bold">{<IntlMessages id="login.title.main-mobile-line-2" />}</label>
          <h5 className="text-white mt-3">{<IntlMessages id="login.title.sub" />}</h5>
        </div>

        {/* Image Center Logo */}
        <div className="m-bg-image "></div>

        {/* Footer Label And Buttons */}
        <div className="m-footer d-flex flex-column justify-content-center">
          <h6 className="text-white text-center my-3">{<IntlMessages id="login.mnc.krungthai" />}</h6>
          <button
            data-next-login-btn
            onClick={nextAuth}
            className="btn button-ktb-next auth-next-button-anim my-2"
            type="button"
          >
            <IntlMessages id="login.tab.normal.label.login.alternative" />
            <img src={ImgNextWhite} className="h-100 ms-1" alt="next logo" />
          </button>
          {enableLogin && (
            <>
              <div className="username-login mt-3">
                <Button
                  className="color-label bg-white username-login-btn"
                  type="primary"
                  shape="round"
                  ghost
                  block
                  onClick={gotoNormalLogin}
                >
                  <IntlMessages id="login.channel.username" />
                </Button>
              </div>
              <div className="accept-login mt-3">
                <div className="mb-0">
                  <DangerousMessage.Div
                    className="custom-message-1"
                    html={intl.formatMessage({
                      id: moment().isBefore(moment("1-11-2022", "DD-MM-YYYY"))
                        ? "login.username-password.warning.expire"
                        : "login.username-password.warning",
                    })}
                  />
                </div>
                <div className="mb-0 d-flex-main">
                  <div style={{ marginBottom: -3 }}>
                    <IntlMessages id="login.username-password.channel-suggest" />
                  </div>
                  <span className="mx-1">
                    <img src={ImgNext} style={{ width: "55px" }} alt="Logo Next" />
                  </span>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  } else {
    return (
      <div className="bg-login">
        <div className="container">
          <div className="row content-login">
            <div className="col-12 col-lg-7 col-md-12" variants={banner}>
              <h2 className="mt-0 mt-lg-3">{<IntlMessages id="login.title.main" />}</h2>
              <h4 className="text-white mb-3  mb-lg-0">{<IntlMessages id="login.title.sub" />}</h4>
              <div className="img-left text-center">
                <img src={Img_left} alt="img-left" className="img-fluid" />
              </div>
            </div>
            <div className="col-12 col-lg-5 col-md-12" variants={screens.md ? fromRight : fromRightMobile}>
              <Credentials />
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default memo(SignInSection);

const banner = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: { delay: 0.4, duration: 0.5 },
  },
};

const fromRight = {
  hidden: { x: 300, opacity: 0 },
  visible: { x: 0, opacity: 1, transition: { delay: 0.4 } },
};
const fromRightMobile = {
  hidden: { x: 50, opacity: 0 },
  visible: { x: 0, opacity: 1, transition: { delay: 0.4 } },
};
